import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent {

  @Input() changedAccordion: string;
  justification: string;

  constructor(public activeModal: NgbActiveModal) { }

  closeModal() {
    this.activeModal.dismiss();
  }
}
